export default __webpack_public_path__ + "static/media/img-slider-tspace-2.54ad68b0.png";